import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { CountryType } from '../../../model';
import { SiteConnector } from '../../../site-context/connectors';
import { normalizeHttpError } from '../../../util';
import { UserActions } from '../actions';
import { ProfileCountriesActionTypes } from '../actions/profile-countries.actions';

@Injectable()
export class ProfileCountriesEffects {
  loadProfileCountries$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProfileCountriesActionTypes.LoadProfileCountries),
      exhaustMap((action: UserActions.LoadProfileCountries) =>
        this.connector.getCountriesByType(action.userId, CountryType.BILLING).pipe(
          map((countries) => new UserActions.LoadProfileCountriesSuccess(countries)),
          catchError((error) => of(new UserActions.LoadProfileCountriesFail(normalizeHttpError(error))))
        )
      )
    )
  );

  constructor(private actions$: Actions, private connector: SiteConnector) {}
}
